
import { Component, Prop, Vue } from "vue-property-decorator";
import { Next, Route } from 'vue-router';
import  ButtonVue from "@/lib/Button.vue";
import { IUser } from "@/../../server/src/user/IUser";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus();

@Component({ })
export default class ModalVue extends Vue {
  
  show_modal:boolean=false;
  key:number=0;

  @Prop(String) width!:string;
  @Prop(String) height!:string;

  async mounted() {   
   
  }



  
  switch_modal(s:boolean) {
    console.log(s)
    this.show_modal=s
    this.key++
  }

  refresh() {
    this.key++
    alert("modal refresh")
  }

  get css_variables () {
    return {
          "--width":  (this.width ? this.width : '92%'),
          "--height": (this.height ? this.height : 'auto')
          }
  }


}
